import { SearchX } from "lucide-react"
import { Card, CardContent } from "./ui/card"
import { Button } from "./ui/button"
import { navigate } from "wouter/use-browser-location"

const IncompleteProfile = () => {
    return (
      <>
      <Card className="w-full max-w-4xl mx-auto shadow pt-6">
          <CardContent>
            <div className="flex flex-col items-center justify-center text-gray-400 p-4 gap-4">
              <SearchX size={200} />
              <p>Company profile is incomplete.</p>
              <Button size="sm" onClick={() => navigate("/company")}>Configure</Button>
            </div>
          </CardContent>
        </Card>
      </>
    )
  }

export default IncompleteProfile;